// @ts-ignore temporary before figuring out a logging solution that works in prod
window.localStorage.setItem('debug', 'doveze*')
